import { SkillDetails } from '@app/template'
import Button from 'components/button/base/Button'
import Dialog from 'components/dialog/base/Dialog'
import { Form, Formik, FormikHelpers as FormikActions } from 'formik'
import { useRequestSkillConvert } from 'helpers/skillHelpers'
import { requestSingleTemplateRevalidation } from 'helpers/templateHelpers'
import { useGlobal } from 'hooks/useGlobal'
import React from 'react'
import { Trans, WithTranslation, withTranslation } from 'react-i18next'
import { compose } from 'recompose'

interface OwnProps {
    skill: SkillDetails
}

type Props = OwnProps & WithTranslation

const ConvertSkillDialog = (props: Props) => {
    const { t } = props

    const {
        createNotification,
        closeActiveOverlay,
        tryCloseDirtyOverlay
    } = useGlobal()

    const initialValues = {}

    const requestSkillConvert = useRequestSkillConvert()
    const onSubmit = async (
        values: unknown,
        formikActions: FormikActions<unknown>
    ) => {
        const { skill } = props

        try {
            const { data: template } = await requestSkillConvert(skill.id)
            await requestSingleTemplateRevalidation(template.id)

            closeActiveOverlay()
        } catch (payload) {
            // TODO: Introduce logging
            formikActions.setSubmitting(false)

            createNotification({
                type: t('error:labels.error'),
                description: t('error:response.convertSkillUnknown', {
                    skillName: skill.name
                })
            })
        }
    }

    return (
        <Dialog
            title={t('templates:convertSkill.title')}
            closeDialog={tryCloseDirtyOverlay}
            showCloseIcon={false}
        >
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <Form className="dialog__form dialog__form--confirm">
                        <div className="dialog__info">
                            <Trans i18nKey="templates:convertSkill.question">
                                <strong>
                                    {{ skillName: props.skill.name }}
                                </strong>
                            </Trans>
                        </div>

                        <div className="dialog__actions dialog__actions--noShadow">
                            <Button
                                title={t('common:labels.cancel')}
                                onClick={closeActiveOverlay}
                                formButton
                            />

                            <Button
                                title={t('common:labels.convert')}
                                type="submit"
                                loading={formikProps.isSubmitting}
                                primary
                                formButton
                                autoFocus
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}

export default compose<Props, OwnProps>(
    withTranslation(['common', 'templates', 'error'])
)(ConvertSkillDialog)
